import React from 'react';
import { useLocation } from 'react-router-dom';
import { Typography, Stack, Badge } from '@mui/material';
import PropTypes from 'prop-types';
import { makeOdometerLabelAE } from '../../../utils/helpers/make-odo-label';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { AUCTION_TYPE, EXPLORE_TABS } from '../../../constants/app-constants';
import { parseLocationSearchParams } from '../../../utils/helpers/parse-location-search-params';
import { getItem } from '../../../utils/helpers/storage-crud';

const colorVariants = {
    active: 'bg-active',
    secondary: 'bg-secondary',
    'card-background': 'bg-card-background'
};
const CardHeader = ({ auction, onlyTitle, isFav, isWatchList, handleFavClick }) => {
    const location = useLocation();
    const { year, make, model, variant, odometerReading, fuelType, engineSize, auctionType } = auction || {};
    const title = `${year} ${make} ${model} - ${variant}`;
    const typeOfAuction = auctionType === AUCTION_TYPE.PAI ? AUCTION_TYPE.OCB : auctionType;
    const { view = '' } = parseLocationSearchParams(location.search);
    const isWebView = getItem('isWebView');
    const renderTag = () => {
        const color = EXPLORE_TABS.find(tab => tab.value === typeOfAuction)?.color;
        return color && <div className={`${colorVariants[color]} rounded-bl py-1 px-4 font-semibold text-xs text-white`}>
            {typeOfAuction}
        </div>;
    };
    return (
        <Stack direction={'horizontal'} justifyContent='space-between'>
            <Stack>
                <Typography gutterBottom className='font-semibold text-lg'>
                    {title}
                </Typography>
                {!onlyTitle && <Stack direction={'row'} spacing={2} justifyContent="start" alignItems="center">
                    <Typography variant="body1" className='text-border font-bold'>
                        {fuelType}
                    </Typography>
                    <Badge color="primary" variant="dot" />
                    <Typography variant="body1" className='text-border font-bold'>
                        {makeOdometerLabelAE(odometerReading)}
                    </Typography>
                    {engineSize && <React.Fragment>
                        <Badge color="primary" variant="dot" />
                        <Typography variant="body1" className='text-border font-bold'>
                            {engineSize?.toFixed(1)}L
                        </Typography>
                    </React.Fragment>}
                </Stack>}
            </Stack>
            <React.Fragment>
               {!isWebView && <div className='absolute right-0 top-0 flex flex-col items-end gap-3.5'>
                    {renderTag()}
                    {view !== 'PD_VIEW' && (isFav && !isWatchList ? <FavoriteIcon onClick={handleFavClick} fontSize="inherit" sx={{ height: '2rem', width: '2rem', marginRight: '1rem' }} color='secondary' /> :
                        !isWatchList && <FavoriteBorderIcon onClick={handleFavClick} fontSize="inherit" sx={{ height: '2rem', width: '2rem', marginRight: '1rem' }} className='text-border' />)
                    }
                </div>}
            </React.Fragment>
        </Stack>
    );
};

CardHeader.propTypes = {
    onlyTitle: PropTypes.bool,
    isWatchList: PropTypes.bool,
    isFav: PropTypes.bool,
    auction: PropTypes.object,
    handleFavClick: PropTypes.func
};

export default CardHeader;
